module.exports = __webpack_public_path__ + "static/media/parques-tematicos.eaa3083d.jpg";